import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { reduce, flatMap, isEmpty } from 'lodash';
import { getRsvpPageEvents } from '../../../../../actions/website/entities/RsvpActions';
import { togglePage, movePage } from '../../../../../actions/website/PageActions';
import { updateRegistryPublish } from '../../../../../actions/RegistryActions';
import { showModal } from '../../../../../actions/ModalActions';
import { addEntity } from '../../../../../actions/website/EntityActions';
import PageHeader from './PageHeader/PageHeader';
import PageList from './PageList/PageList';
import './Pages.styles.less';


class Pages extends React.Component {
  componentDidMount() {
    this.props.getRsvpEntities();
  }

  handleOnRegistryPublish = (value) => {
    const { registry, setShippingAddress, toggleVisibility } = this.props;

    if (registry.has_shipping_address) {
      toggleVisibility(value);
    } else {
      setShippingAddress();
    }
  }

  handlePageToggle = (pageId, currentPage) => {
    const currentPageType = currentPage.type;
    const { page, guests, rsvpEntities, orderedIds, onPageToggle, showErrorModal, showSuccessModal } = this.props;

    const numGuestsInvited = reduce(guests.orderedIds, (sum, guestGroupId) => {
      const guestGroup = guests.byId[guestGroupId];
      const eventInvitations = flatMap(guestGroup.guests, guest => guest.event_invitations);
      return sum + eventInvitations.length;
    }, 0);
    const noEvents = orderedIds.length === 0;
    const currentPageTypeIsRsvp = currentPageType === 'RSVP';
    const noGuests = isEmpty(guests.byId);
    const noGuestsInvited = numGuestsInvited === 0;
    const rsvpDisabled = orderedIds.filter(id => rsvpEntities[id].collect_rsvps === true).length === 0;

    if (!page.hidden) {
      onPageToggle(pageId);
    } else if (currentPageTypeIsRsvp && noEvents) {
      const errorModalProps = {
        heading: 'Want guests to RSVP on your wedding website?',
        body: 'First, create an event and build a guest list for it. Then you\'ll be able to unhide this page and let guests RSVP on this page',
        button: {
          text: 'Create An Event',
          action: () => browserHistory.push('/wedding/manage/events')
        }
      };
      showErrorModal(errorModalProps);
    } else if (currentPageTypeIsRsvp && noGuests) {
      const errorModalProps = {
        heading: 'Want guests to start using this page?',
        body: 'First, build your Guest Directory.',
        button: {
          text: 'Go To Guest Directory',
          action: () => browserHistory.push('/wedding/manage/guests/all')
        }
      };
      showErrorModal(errorModalProps);
    } else if (currentPageTypeIsRsvp && noGuestsInvited) {
      const errorModalProps = {
        heading: 'Want guests to start using this page?',
        body: 'First, choose some to invite.',
        button: {
          text: 'Invite Guests',
          action: () => browserHistory.push('/wedding/manage/guests/build')
        }
      };
      showErrorModal(errorModalProps);
    } else if (currentPageTypeIsRsvp && rsvpDisabled) {
      const errorModalProps = {
        heading: 'Want guests to start using this page?',
        body: 'Turn on online RSVPs for at least one of your events (and make sure guests have already been invited).',
      };
      showErrorModal(errorModalProps);
    } else if (currentPageTypeIsRsvp && page.hidden) {
      showSuccessModal();
      onPageToggle(pageId);
    } else {
      onPageToggle(pageId);
    }
  }

  render() {
    const { pages, registry, onSortEnd, hasRegistry, handleOpenRegistryModal } = this.props;

    return (
      <div className="mpr-pages">
        <PageHeader />
        <PageList
          pages={pages.byId}
          orderedIds={pages.orderedIds}
          onToggle={this.handlePageToggle}
          onSortEnd={onSortEnd}
          useDragHandle
          lockAxis="y"
          registry={registry}
          hasRegistry={hasRegistry}
          registryPublished={registry.is_public}
          onRegistryPublish={this.handleOnRegistryPublish}
          helperClass="mpr-dragging-helper-class"
          handleOpenRegistryModal={handleOpenRegistryModal}
        />
      </div>
    );
  }
}

Pages.propTypes = {
  pages: PropTypes.shape({}),
  onSortEnd: PropTypes.func,
  showSuccessModal: PropTypes.func,
  showErrorModal: PropTypes.func,
  page: PropTypes.shape({}),
  guests: PropTypes.shape({}),
  rsvpEntities: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  onPageToggle: PropTypes.func,
  getRsvpEntities: PropTypes.func,
  handleOpenRegistryModal: PropTypes.func.isRequired,
  hasRegistry: PropTypes.bool,
  registry: PropTypes.shape({}),
  toggleVisibility: PropTypes.func,
  setShippingAddress: PropTypes.func,
};

const mapStateToProps = state => ({
  pages: state.website.pages,
  guestGroups: state.guestList.guests.byId,
  events: state.events.events.orderedIds,
  rsvpEntities: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.RSVP],
  guests: state.guestList.guests,
  hasRegistry: state.user.userContext.registry_ids.length > 0,
  registry: state.registry
});

const mapDispatchToProps = dispatch => ({
  showErrorModal: errorModalProps => dispatch(showModal('PUBLISH_PAGE_ERROR', { ...errorModalProps }, { size: 'md' })),
  showSuccessModal: () => dispatch(showModal('PUBLISH_RSVP', {}, { size: 'md' })),
  onSortEnd: ({ oldIndex, newIndex }) => {
    if (oldIndex > 0 && newIndex > 0) {
      dispatch(movePage(oldIndex, newIndex));
    }
  },
  getRsvpEntities: () => dispatch(getRsvpPageEvents()),
  onPageToggle: pageId => dispatch(togglePage(pageId)),
  handleOpenRegistryModal: () => {
    dispatch(addEntity());
    dispatch(showModal('REGISTRY', {}, { size: 'md' }));
  },
  toggleVisibility: (value) => {
    if (value) {
      return dispatch(updateRegistryPublish(value)).then(() => dispatch(showModal('PUBLISH_REGISTRY', {}, { size: 'md' })));
    }
    return dispatch(updateRegistryPublish(value));
  },
  setShippingAddress: () => dispatch(showModal('SET_SHIPPING_ADDRESS', {}, { size: 'md' })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pages);



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/Pages/Pages.jsx